import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loading from '@doordash/component-loading';
import { AdminPageSubpageContentContainer } from '../AdminPage/AdminPageStyles';
import { getSelectedTeamAccount, getSelectedTeamAccountContent, } from '../../selectors/uiSelector';
import { useIsOnboardingFinished } from './Onboarding/useGetCompletedOnboardingStepsQuery';
import { TEAM_ACCOUNT_PAYMENT_METHOD } from '../../types/portal_data';
import { EXPENSED_MEALS_STATUS } from '../../types/expensed_meal';
import { WorkBenefit } from '../../types/GloblalTypes';
import { useDVSNumber } from '@doordash/lib-dvs-client/lib/react';
import { DV2_NAMES, dv2DefaultsNonBoolean } from '../DV2';
import EmOnboarding from './EmOnboardingV2/EmOnboarding';
import OnboardingContainerV1 from './Onboarding/Onboarding';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import track from '../../utils/track';
import { OnboardingEvents } from '../../constants/events';
export var OnboardingContainer = function () {
    var _a, _b;
    var history = useHistory();
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    // If EM is inactive, we are onboarding DP
    // This is because EM is active right away when onboarding EM
    var isOnboardingDashPass = ((_a = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.expensedMeals) === null || _a === void 0 ? void 0 : _a.status) === EXPENSED_MEALS_STATUS.INACTIVE;
    var workBenefit = isOnboardingDashPass
        ? WorkBenefit.WORK_BENEFIT_DASHPASS
        : WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS;
    var isExpensedMealInvoicing = ((_b = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.expensedMeals) === null || _b === void 0 ? void 0 : _b.paymentMethod) ===
        TEAM_ACCOUNT_PAYMENT_METHOD.INVOICING;
    var _c = useIsOnboardingFinished(teamAccountId), isOnboardingFinished = _c.isOnboardingFinished, isOnboardingInProgress = _c.isOnboardingInProgress, isLoadingStep = _c.loading, completedSteps = _c.completedSteps;
    var selfServeEmOnboardingVersion = useDVSNumber(DV2_NAMES.ddfwSelfServeEmOnboarding, dv2DefaultsNonBoolean.ddfwSelfServeEmOnboarding);
    if (isLoadingStep) {
        return (React.createElement(AdminPageSubpageContentContainer, null,
            React.createElement(Loading, null)));
    }
    if (isOnboardingFinished) {
        history.push(PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/members");
        return null;
    }
    track(OnboardingEvents.VERSION_VIEW, {
        onboarding_version: selfServeEmOnboardingVersion,
        work_benefit: workBenefit,
    });
    if (workBenefit === WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS &&
        selfServeEmOnboardingVersion === 2) {
        return (React.createElement(EmOnboarding, { onboardingVersion: selfServeEmOnboardingVersion, isEmInvoicing: isExpensedMealInvoicing, isOnboardingInProgress: isOnboardingInProgress, completedSteps: completedSteps }));
    }
    return (React.createElement(OnboardingContainerV1, { onboardingVersion: selfServeEmOnboardingVersion }));
};
export default OnboardingContainer;
